import { Dialog, DialogTitle, DialogContent, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer-continued';
import { useTranslate } from 'react-admin';

interface DiffViewerDialogProps {
  open: boolean;
  onClose: () => void;
  oldData: any;
  newData: any;
}

const DiffViewerDialog = ({ open, onClose, oldData, newData }: DiffViewerDialogProps) => {
  const oldValue = typeof oldData === 'string' ? oldData : JSON.stringify(oldData, null, 2);
  const newValue = typeof newData === 'string' ? newData : JSON.stringify(newData, null, 2);
  const translate = useTranslate();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          minHeight: '60vh',
          maxHeight: '90vh',
        },
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {translate('module.auditLogs.changes')}
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ overflow: 'auto' }}>
          <ReactDiffViewer
            oldValue={oldValue || '{}'}
            newValue={newValue || '{}'}
            splitView
            compareMethod={DiffMethod.WORDS}
            leftTitle={translate('module.auditLogs.oldData')}
            rightTitle={translate('module.auditLogs.newData')}
            styles={{
              variables: {
                light: {
                  diffViewerBackground: '#fff',
                  addedBackground: '#e6ffec',
                  addedColor: '#24292f',
                  removedBackground: '#ffebe9',
                  removedColor: '#24292f',
                  wordAddedBackground: '#abf2bc',
                  wordRemovedBackground: '#ff818266',
                  addedGutterBackground: '#ccffd8',
                  removedGutterBackground: '#ffd7d5',
                  gutterBackground: '#f6f8fa',
                  gutterBackgroundDark: '#f0f1f2',
                  highlightBackground: '#fffbdd',
                  highlightGutterBackground: '#fff5b1',
                },
              },
              contentText: {
                fontSize: '13px',
                fontFamily: 'monospace',
              },
            }}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DiffViewerDialog;
